module.exports = __webpack_public_path__ + "static/moreno-640c11c9fb62dcb07741663396864fb9.jpeg";